export default __webpack_public_path__ + "static/media/852hz-higher-consciousness.70a02a2f.ogg";